import {
  GET_SEND_PRODUCT_WW_REQUEST,
  GET_SEND_PRODUCT_WW_SUCCESS,
  GET_SEND_PRODUCT_WW_ERROR
} from "./types.js";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const sendProductWW = (token, values) => (dispatch) => {
  dispatch({ type: GET_SEND_PRODUCT_WW_REQUEST });
  const newData = {
    values
};
  return axios({
    method: "POST",
    url: `${BASEURL}create/producttobergenWW`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_SEND_PRODUCT_WW_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SEND_PRODUCT_WW_ERROR,
        payload: [],
      });
    });
};
